import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { EVENT_ROLE_ICONS, EventRole } from 'src/app/types/event-access.types';

/** `role` con el que el sheet se cierra al elegir; cualquier otro cierre no cambia nada. */
export const EVENT_ROLE_SHEET_SELECT = 'select';

interface RoleOption {
  readonly role: EventRole;
  readonly labelKey: string;
  readonly icon: string;
  readonly active: boolean;
}

/** Sheet del chip de rol: los roles con los que el usuario puede ver este evento. */
@Component({
  selector: 'app-event-role-sheet',
  templateUrl: './event-role-sheet.component.html',
  styleUrls: ['./event-role-sheet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EventRoleSheetComponent implements OnInit {
  /**
   * `@Input` clásicos, no `input()`: `ModalController.create({ componentProps })` asigna las
   * propiedades directamente y pisaría la señal (`this.roles is not a function`).
   */
  @Input() roles: readonly EventRole[] = [];
  @Input() activeRole: EventRole | null = null;

  options: readonly RoleOption[] = [];

  ngOnInit(): void {
    this.options = this.roles.map(role => ({
      role,
      labelKey: `event-access.roles.${role}`,
      icon: EVENT_ROLE_ICONS[role],
      active: role === this.activeRole,
    }));
  }

  constructor(private readonly modalCtrl: ModalController) {}

  select(role: EventRole): Promise<boolean> {
    return this.modalCtrl.dismiss(role, EVENT_ROLE_SHEET_SELECT);
  }
}
